import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TODO } from '@/types'

const emptyGuardianConsent = (): TODO => ({
  address: {
    street: null,
    buildingNumber: null,
    flatNumber: null,
    postalCode: null,
    city: null
  },
  parentInfo: {
    inquiryDescription: null,
    inquiryPride: null,
    inquiryHelp: null,
    inquiryDifficulty: null,
    inquiryLike: null
  },
  childApplication: {
    futureSelf: null,
    threeWordsDescription: null,
    reasonsForHappiness: null,
    superpower: null,
    worldChange: null,
    applicationReason: null,
    dream: null
  },
  extraField: {
    futureProfessions: ['']
  }
})

export const useGuardianConsentStore = defineStore('guardianConsent', () => {
  const disableCheckbox = ref({
    isStreetDisabled: false
  })
  const guardianConsent = ref(emptyGuardianConsent())

  const clearGuardianConsent = () => {
    guardianConsent.value = emptyGuardianConsent()
    disableCheckbox.value.isStreetDisabled = false
  }

  const updateGuardianConsentField = (
    fieldValue: unknown,
    guardianConsentField: string,
    key: string
  ) => {
    if (key === 'street') {
      disableCheckbox.value.isStreetDisabled = !fieldValue
    }
    guardianConsent.value[guardianConsentField][key] = fieldValue
  }

  const setGuardianConsent = (fields: Record<string, unknown>) => {
    if (!fields) return
    Object.keys(guardianConsent.value).forEach((guardianConsentField) => {
      Object.entries(guardianConsent.value[guardianConsentField]).forEach(([key]) => {
        const fieldValue = fields[key]
        if (typeof fieldValue === 'undefined') return
        updateGuardianConsentField(fieldValue, guardianConsentField, key)
      })
    })
  }

  return {
    guardianConsent,
    disableCheckbox,
    clearGuardianConsent,
    setGuardianConsent
  }
})
